<template>
  <div class="main">
    <Header
      :show="true"
      title="车辆道闸"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="请先观察现场情况，在确保安全的情况下放行。"
      />
      <van-form>
        <van-cell
          :value="listQuery.area.name"
          is-link
          required
          @click="listQuery.area.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">访问区域</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.area.show"
          :actions="renderAreaList"
          cancel-text="取消"
          description="请选择访问区域"
          @select="onSelectAreaChoose"
        />
        <van-cell
          :value="listQuery.opt.name || '请选择'"
          is-link
          required
          @click="listQuery.opt.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">操作类型</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.opt.show"
          :actions="renderActiveList"
          cancel-text="取消"
          description="请选择操作类型"
          @select="onSelectOptChoose"
        />
        <van-cell
          v-if="listQuery.area.name !== '平推门'"
          :value="listQuery.reason.name"
          is-link
          required
          @click="listQuery.reason.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">放行理由</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="listQuery.reason.show"
          :actions="listQuery.reason.actions"
          cancel-text="取消"
          description="请选择放行理由"
          @select="onSelectReasonChoose"
        />
        <div
          v-if="checkPermission([312])"
          style="margin: 16px"
        >
          <van-button
            round
            block
            type="info"
            @click="handleOperateConfirmDialog"
          >
            确定
          </van-button>
        </div>
      </van-form>

      <van-dialog
        v-model="dialogVisibleOperate"
        title="确认放行？"
        show-cancel-button
        :before-close="handleBeforeCloseDialog"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2vh;
            margin: 20px 0;
          "
        >
          放行区域：{{ listQuery.area.name }}
        </div>
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import {
  updateOfficeGateOne,
  updateMaterialGateOne,
  updateGate,
  entranceDoorGate,
} from "@/api/car.js";

export default {
  name: "ServiceControlCar",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      loading: false,
      dialogVisibleOperate: false,
      listQuery: {
        area: {
          show: false,
          actions: [
            { name: "小车道", value: 0, permission: 3181 },
            { name: "原料车道", value: 1, permission: 3182 },
            { name: "商砼车道", value: 2, permission: 3183 },
            { name: "平推门", value: 3, permission: 3184 },
          ],
          name: "小车道",
        },
        opt: {
          show: false,
          actions: [
            { name: "关闭道闸", value: 0, permission: 313 },
            { name: "开启道闸", value: 1, permission: 314 },
            { name: "停止道闸", value: 2, permission: 315 },
            { name: "锁定道闸", value: 3, permission: 316 },
            { name: "解锁道闸", value: 4, permission: 317 },
          ],
          ptActions: [
            { name: "关闭", value: "close", permission: 313 },
            { name: "开启", value: "open", permission: 314 },
            { name: "暂停", value: "pause", permission: 315 },
          ],
          name: "",
        },
        switch: 0,
        reason: {
          show: false,
          actions: [
            { name: "临时放行", subname: "" },
            { name: "系统故障" },
            { name: "其他" },
          ],
          name: "",
        },
      },
    };
  },
  computed: {
    renderAreaList() {
      let list = this.listQuery.area.actions.reduce((prev, item) => {
        if (checkPermission([item.permission])) prev.push(item);
        return prev;
      }, []);

      return list;
    },
    renderActiveList() {
      let list = [];

      if (this.listQuery.area.name === "平推门") {
        list = this.listQuery.opt.ptActions.reduce((prev, item) => {
          if (checkPermission([item.permission])) prev.push(item);
          return prev;
        }, []);
      } else {
        list = this.listQuery.opt.actions.reduce((prev, item) => {
          if (checkPermission([item.permission])) prev.push(item);
          return prev;
        }, []);
      }

      return list;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    handleClickRight() {
      console.log("control-left");
    },
    onSelectAreaChoose(item) {
      this.listQuery.area.show = false;
      this.listQuery.area.name = item.name;
      this.listQuery.opt.name = "";
    },
    onSelectOptChoose(item) {
      this.listQuery.opt.show = false;
      this.listQuery.opt.name = item.name;
    },
    onSelectReasonChoose(item) {
      this.listQuery.reason.show = false;
      this.listQuery.reason.name = item.name;
    },
    handleOperateConfirmDialog() {
      if (!this.listQuery.opt.name) {
        showPhoneAlarm(true, "toast", null, 2000, 500, null, "请选择操作类型");
        return;
      }
      if (
        this.listQuery.area.name !== "平推门" &&
        this.listQuery.reason.name === ""
      ) {
        showPhoneAlarm(true, "toast", null, 2000, 500, null, "请选择放行事由");
        return;
      }
      this.dialogVisibleOperate = true;
    },
    async handleBeforeCloseDialog(action, done) {
      if (action === "confirm") {
        let request;
        if (this.listQuery.area.name === "平推门") {
          const { opt } = this.listQuery;
          const payload = {
            opt: opt.ptActions.find((item) => item.name === opt.name).value,
          };

          request = entranceDoorGate(payload);
        } else {
          const { area, opt, reason } = this.listQuery;

          const payload = {
            gate: area.actions.find((item) => item.name === area.name).value,
            opt: opt.actions.find((item) => item.name === opt.name).value,
            reason: reason.name,
          };
          request = updateGate(payload);
        }

        const { data: reqData } = await request.finally(() => {
          this.loading = false;
        });
        if (
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            reqData.code,
            "道闸放行",
            reqData.msg
          )
        ) {
          done(true);
        }
      } else {
        showPhoneAlarm(true, "toast", "success", 2000, 200, null, "取消放行");
        done(true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改

// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
